export default __webpack_public_path__ + "static/media/852.3a15b3fe.gif";